var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultImgg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    rx: 12,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.623 46.3587C44.2924 46.3587 46.4563 44.1947 46.4563 41.5254C46.4563 38.856 44.2924 36.692 41.623 36.692C38.9536 36.692 36.7897 38.856 36.7897 41.5254C36.7897 44.1947 38.9536 46.3587 41.623 46.3587Z",
    fill: "#D1D5DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.413 26.832H46.1663C35.4888 26.832 26.833 35.4879 26.833 46.1654V56.412C26.833 67.0895 35.4888 75.7454 46.1663 75.7454H56.413C67.0905 75.7454 75.7463 67.0895 75.7463 56.412V46.1654C75.7463 41.0378 73.7094 36.1203 70.0837 32.4946C66.458 28.8689 61.5405 26.832 56.413 26.832ZM46.1663 30.457H56.413C64.2573 30.4693 70.8902 36.2666 71.9522 44.0387H68.2063C58.121 44.0469 48.7955 49.3995 43.7013 58.1037C40.5201 55.5766 36.575 54.2048 32.5122 54.2129H30.458V46.1654C30.4713 37.4954 37.4964 30.4703 46.1663 30.457ZM32.5122 57.8379H30.5305C31.0555 63.537 34.6385 68.4996 39.883 70.7912C40.0562 67.5653 40.7838 64.3934 42.0338 61.4145C39.3959 59.1117 36.0138 57.8413 32.5122 57.8379ZM56.413 72.1204H46.1663C45.2578 72.1168 44.3516 72.0277 43.4597 71.8545C43.7614 58.3969 54.7454 47.6382 68.2063 47.6154H72.1213V56.412C72.108 65.082 65.083 72.1071 56.413 72.1204Z",
    fill: "#D1D5DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImgg);
export default __webpack_public_path__ + "static/media/defaultImgg.c5baea1908115afa725385fc8db36d5e.svg";
export { ForwardRef as ReactComponent };